export default "<${htmlTag} src=\"https://sportradarserving.com/pixel?id=${id}&type=${tagType}&aid=${businessEntityDspId}\"/>\n";